module.exports = __webpack_public_path__ + "assets/img/hero-bg.06e5943e.svg";